export default
{
  'messages': {
    'req_in_que': 'Váš požadavek se zpracovává. Počkejte na vyzvání.',
    'please_enter': 'Vstupte',
    'doing': 'Vyřizuje se',
  },
}
